import styled from '@emotion/styled'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
})